import styled, { css } from 'styled-components';
import { key, palette } from 'styled-theme';

import { media } from '../../../helper/styleHelper';

import Label from '../label';

export const TableContainer = styled.div``;

export const StyledTable = styled.table`
  border-spacing: 0px 0px;
  top: 0;
  position: relative;
  width: 100%;
  padding: 0 5px;
`;

export const TableHead = styled.thead`
  tr {
    &::after {
      content: '';
      position: absolute;
      top: 0px;
      left: -5px;
      bottom: 5px;
      right: -5px;
      z-index: -1;
      border-radius: 4px 4px 0px 0px;
      border: 1px solid ${palette('border', 1)};
      ${(props) =>
        props.notRequireEmptyState
          ? css`
              background-color: ${palette('background', 0)};
            `
          : css`
              background-color: ${palette('background', 0)};
            `}
    }
  }
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  position: relative;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: 0px;
    left: -5px;
    bottom: 0px;
    right: -5px;
    margin-bottom: 4px;
    z-index: -1;
    border: 1px solid ${palette('border', 1)};
    ${(props) =>
      props.notRequireEmptyState
        ? css`
            background-color: ${palette('background', 0)};
          `
        : css`
            background-color: ${palette('background', 0)};
          `};
    ${(props) =>
      props.hasFooter
        ? css``
        : css`
            border-radius: 0px 0px 4px 4px;
            border: 1px solid ${palette('border', 1)};
          `}
  }

  th {
    padding: 12px 20px 20px 20px;
  }
  td {
    padding: 10px 20px 12px 20px;
    box-sizing: border-box;
    word-wrap: break-word;
  }
`;

export const TableHeaderCell = styled.th`
  text-align: left;
  letter-spacing: 0px;
  color: ${palette('text', 1)};
  cursor: default !important;
  opacity: 1;

  ${(props) =>
    props?.width
      ? css`
          width: ${props?.width};
        `
      : css``}
  ${(props) =>
    props?.extraHeaderPadding
      ? css`
          padding: ${key('sizes.gutter.custom', '15px')} !important;
        `
      : css``}
  ${media.xl`
  font-size: 14px;
  `}
  ${media.xlr`
  font-size: 14px;
  `}
  ${media.xxl`
  font-size:14px;
  `}
  ${media.vxxl`
  font-size:14px;
  `}
`;

export const TableDataCell = styled.td`
  text-align: left;
  letter-spacing: 0px;
  color: ${palette('text', 1)};
  opacity: 1;

  max-width: ${key('sizes.gutter.200', '200px')};

  ${media.xl`
  font-size:14px;
  `}
  ${media.xlr`
  font-size:14px;
  `}
  ${media.xxl`
  font-size:14px;
  `}
`;
export const TableFooter = styled.tfoot``;
export const TableFooterRow = styled(TableRow)``;

export const TableFooterCell = styled.td`
  color: #0f0f0f;
  opacity: 1;
  cursor: pointer;

  min-width: fit-content;
  ${media.xxl`
  font-size:14px;
  min-width: fit-content;
  `}
`;

export const SortIcon = styled.img`
  width: 9.59px;
  height: 19.79px;
  margin-left: 5.79px;
  vertical-align: text-bottom;
`;
export const BackgroundBlock = styled.div``;

export const HeaderCellWithIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${key('sizes.gutter.tiny', '10px')};
  font-size: 14px;
  color: ${palette('text', 1)};
`;

export const SortIconWrapper = styled.div`
  display: grid;
  grid-auto-flow: row;
  align-items: center;
  gap: 2px;
`;

export const SortingIcon = styled.img`
  cursor: pointer;
`;

export const TableEmptyState = styled.div`
  display: grid;
  grid-auto-flow: row;
  align-items: center;
  justify-items: center;
`;

export const EmptyStateContainer = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
`;

export const StyledEmptyStateText = styled(Label)`
  padding-top: ${key('sizes.gutter.15', '15px')};
  text-align: center;
  color: ${palette('text', 1)};
`;

export const TablePaginationWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
  align-items: center;
  justify-self: flex-end;
  gap: ${key('sizes.gutter.normal', '25px')};
  padding: 18px 20px 30px;
`;
export const PaginationTitle = styled(Label)`
  position: absolute;
  left: 20px;
  color: ${palette('text', 1)};
  font-size: 14px;
`;
export const PaginationRight = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: ${key('sizes.gap.tiny', '5px')};
  align-items: center;
  cursor: pointer;
`;
export const PaginationLeft = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: ${key('sizes.gap.tiny', '5px')};
  align-items: center;
  cursor: pointer;
`;
export const PaginationButton = styled(Label)`
  font-size: 14px;
  ${(props) =>
    props?.disabled
      ? css`
          color: ${palette('gray', 1)} !important;
        `
      : css`
          color: ${palette('color', 0)} !important;
        `}
`;
